









import { Component, Prop, Vue } from 'vue-property-decorator';
import TextInput from './_text.input.vue';
@Component({
  components: {
    'text-input': TextInput
  },
})
export default class InputCity extends Vue {
  @Prop()
  placeholder!: string;
  public label = 'Ciudad de residencia';
  public error = '';
  public icon = 'location_city'
  public cities = ['Funza', 'Mosquera', 'Madrid', 'Bogotá']
  public selectedCity = '';

  private mounted(){
    this.selectedCity = this.placeholder;
  }

  onChange($text) {
    console.error($text)
      if($text.length === 0){
          this.error = 'Ciudad invalida';
      } else {
        this.$emit('nChange', $text)
          this.error = '';
      }
  }

}
